import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ProfileSearchForm, {
  DEFAULT_SEARCH,
} from "../components/ProfileSearchForm";
import { useMasterData } from "../context/MasterDataContext";
import { search_profiles } from "../api/serverWrapper";
import logo from "../assests/images/app_logo.png";
import "../Styles/ProfileSearch.css";

export default function SearchProfiles() {
  const navigate = useNavigate();
  const location = useLocation();
  const { religionMasterData = [], allCasteMasterData = [] } = useMasterData();

  const [criteria, setCriteria] = useState(
    location.state?.criteria || DEFAULT_SEARCH,
  );
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError("");
      try {
        const resp = await search_profiles({
          Gender: criteria.lookingFor === "Man" ? 1 : 2,
          AgeFrom: Number(criteria.ageFrom),
          AgeTo: Number(criteria.ageTo),
          ReligionId: criteria.religionId ? Number(criteria.religionId) : null,
          LanguageId: criteria.languageId ? Number(criteria.languageId) : null,
        });
        if (!cancelled) setProfiles(resp?.data || []);
      } catch (e) {
        console.error("Profile search failed", e);
        if (!cancelled) {
          setProfiles([]);
          setError("We couldn't load profiles right now. Please try again.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [criteria]);

  const religionName = (id) =>
    religionMasterData.find((r) => r.ReligionId === id)?.ReligionName;
  const casteName = (id) =>
    allCasteMasterData.find((c) => c.CasteL2Id === id)?.CasteName;

  return (
    <div className="ps-page">
      <div className="ps-page-header">
        <div className="ps-page-top">
          <button className="ps-back" onClick={() => navigate("/home")}>
            &lt; Back
          </button>
          <img src={logo} alt="Wedluk Logo" />
        </div>
        <ProfileSearchForm
          key={JSON.stringify(criteria)}
          initial={criteria}
          onSubmit={setCriteria}
          compact
        />
      </div>

      <div className="ps-results-wrap">
        {loading ? (
          <div className="ps-loader" />
        ) : error ? (
          <div className="ps-state">{error}</div>
        ) : profiles.length === 0 ? (
          <div className="ps-state">
            No profiles match your search. Try widening the age range or
            choosing “Any” for religion or mother tongue.
          </div>
        ) : (
          <div className="ps-grid">
            {profiles.map((item) => {
              const photo =
                item.ProfilePhotoUrl ||
                (item.Gender === 1
                  ? require("../assests/images/MaleDefaultIcon.png")
                  : require("../assests/images/FeMaleDefaultIcon.png"));
              return (
                <div
                  key={item.ProfileId}
                  className="ps-card"
                  // full profiles are only visible after signing in
                  onClick={() => navigate("/loginpage")}
                >
                  <div className="ps-card-top">
                    <img className="ps-photo ps-blur" src={photo} alt="" />
                    <div>
                      {/* names are never sent by the API; placeholder is blurred */}
                      <h6 className="ps-name ps-blur">Wedluk Member</h6>
                      <p className="ps-sub">
                        {religionName(item.ReligionId) || "—"} |{" "}
                        {item.CasteName || casteName(item.CasteLevel2Id) || "—"}
                      </p>
                      {item.Age != null && <p className="ps-meta">Age: {item.Age}</p>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
